import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_LIST_OF_PROGRAMS, GET_LIST_OF_PROGRAMS_ERROR, GET_LIST_OF_PROGRAMS_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getListOfPrograms({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/programs`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_LIST_OF_PROGRAMS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LIST_OF_PROGRAMS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LIST_OF_PROGRAMS_ERROR, payload: error });
  }
}

export function* watchGetListOfPrograms() {
  yield takeEvery(GET_LIST_OF_PROGRAMS, getListOfPrograms);
}

function* getListOfProgramsSaga() {
  yield all([fork(watchGetListOfPrograms)]);
}

export default getListOfProgramsSaga;
